import { render, staticRenderFns } from "./PopupSearchToSendComponent.vue?vue&type=template&id=14482b52&scoped=true"
import script from "./PopupSearchToSendComponent.vue?vue&type=script&lang=js"
export * from "./PopupSearchToSendComponent.vue?vue&type=script&lang=js"
import style0 from "./PopupSearchToSendComponent.vue?vue&type=style&index=0&id=14482b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14482b52",
  null
  
)

export default component.exports